import React, { Fragment } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

// Components
import SocialMediaMention from "../components/Card/SocialMediaMention";
import DigitalAverageCount from "../components/Card/Average";
import DigitalAverageMentionCount from "../components/Card/AverageMention";
import SentimentChart from "../components/Chart/Sentiment";
import RecentPosts from "../components/Card/RecentPosts";
import TopAverageChart from "../components/Chart/TopAverageBar";
import EmptyData from "../components/EmptyData";

// Material Icons
import XIcon from "@mui/icons-material/X";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ThreePOutlinedIcon from "@mui/icons-material/ThreePOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import BlurOnOutlinedIcon from "@mui/icons-material/BlurOnOutlined";

export default function TwitterPage({ ...props }) {
  const { data } = props;

  const sortTopRetweet = (array) => {
    const filteredRetweetData = array.sort((a, b) => {
      return b.retweet_count - a.retweet_count;
    });

    return filteredRetweetData.slice(0, 6);
  };

  const sortTopReply = (array) => {
    const filteredReplyData = array.sort((a, b) => {
      return b.reply_count - a.reply_count;
    });

    return filteredReplyData.slice(0, 6);
  };

  const sortSentimentLength = (array, sentiment) => {
    const filteredData = array.filter((x) => x.sentiment === sentiment);
    return filteredData.length;
  };

  return (
    <Fragment>
      {data?.data?.length > 0 ? (
        <Grid container spacing={4} sx={{ pb: 8 }}>
          <Grid item xs={12} md={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                      Digital Mention
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <SocialMediaMention icon={<XIcon />} data={data} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DigitalAverageCount
                      average={data.average_engagement}
                      isAverage={true}
                      title="Average Engagement"
                      icon={
                        <ThreePOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DigitalAverageCount
                      average={data.total_retweet}
                      isAverage={false}
                      title="Total Retweet"
                      icon={
                        <ThumbUpOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DigitalAverageCount
                      average={data.total_favorite}
                      isAverage={false}
                      title="Total Favorite"
                      icon={
                        <FavoriteBorderOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DigitalAverageCount
                      average={data.total_reply}
                      isAverage={false}
                      title="Total Reply"
                      icon={
                        <ChatOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                  Sentiment Percentage Analysis
                </Typography>
                <SentimentChart sentiment={data} />
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                      Sentiment Analysis
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Netral")}
                      isAverage={true}
                      title="Total of Netral Sentiment"
                      icon={
                        <BlurOnOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Negatif")}
                      isAverage={true}
                      title="Total of Negatif Sentiment"
                      icon={
                        <ThumbDownOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Positif")}
                      isAverage={true}
                      title="Total of Positive Sentiment"
                      icon={
                        <ThumbUpOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                      Most Mentioned Account
                    </Typography>
                  </Grid>
                  {Object.keys(data.most_mention_account).map((key) => (
                    <Grid item xs={12} md={4}>
                      <DigitalAverageMentionCount
                        count={data.most_mention_account[key]}
                        title={key}
                        link={"https://x.com/" + key}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" fontWeight="600">
                  Average Retweet
                </Typography>
                <TopAverageChart
                  data={data.data}
                  type="retweet_count"
                  socialMediaType="Twitter"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" fontWeight="600">
                  Average Reply
                </Typography>
                <TopAverageChart
                  data={data.data}
                  type="reply_count"
                  socialMediaType="Twitter"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" fontWeight="600" sx={{ mb: 3 }}>
                  Top Retweet Post
                </Typography>
                <RecentPosts
                  data={sortTopRetweet(data.data)}
                  type={"Twitter"}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" fontWeight="600" sx={{ mb: 3 }}>
                  Top Reply Post
                </Typography>
                <RecentPosts data={sortTopReply(data.data)} type={"Twitter"} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <EmptyData />
      )}
    </Fragment>
  );
}
